import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import SIMAC from 'assets/images/GuiasUsuarios/Centro_ayuda_SIMAC_logo.svg';
import './ModalInfoSIMAC.scss';

const ModalInfoSIMAC = ({ open, onCancel }) => {
  const handleClose = () => {
    onCancel();
  };

  return (
    <Modal
      className="modal-informativo-centro-ayuda"
      width="61%"
      open={open}
      onCancel={handleClose}
      style={{ top: 65, right: -225, maxWidth: 'calc(100% - 40px)' }}
      footer={null}>
      <div className="modal-informativo-container">
        <div className="image-simac-logo">
          <img className="simac-logo" src={SIMAC} alt="" />
        </div>
        <div className="informacion-centro-ayuda">
          <p>
            <h3>Sistema Integral de Monitoreos de Actividades de Campo (SIMAC)</h3>
            Es una herramienta para realizar{' '}
            <span className="span-inf-ctro-ayuda">
              monitoreos de espectaculares, propaganda en vía pública, internet, medios impresos y
              visitas de verificación a casas o eventos de los Sujetos Obligados&nbsp;
            </span>
            (aspirantes a candidaturas, candidaturas independientes, precandidaturas, candidaturas)
            en <span className="span-inf-ctro-ayuda">actos previos al proceso electoral</span>, en{' '}
            <span className="span-inf-ctro-ayuda">procesos electorales</span>, así como en su caso
            la <span className="span-inf-ctro-ayuda">revocación de mandato</span> y durante el año
            para las visitas de verificación del{' '}
            <span className="span-inf-ctro-ayuda">gasto programado</span> en su periodo.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ModalInfoSIMAC;

ModalInfoSIMAC.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired
};
